// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1UserSchema } from './v1/userSchema';

export const getCurrentUserPathParamsSchema = z.object({
  account_id: z.number().int().describe("Workspace id"),
});

export const getCurrentUserHeaderParamsSchema = z.object({
  Authorization: z.optional(z.coerce.string()),
});

/**
 * @description current user
 */
export const getCurrentUser200Schema = z.lazy(() => v1UserSchema);

export const getCurrentUserQueryResponseSchema = z.lazy(() => getCurrentUser200Schema);
